import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPShopTabsBarUI from './PDPShopTabsBarUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBarPlaceholder';
const PDPShopTabsBarInner = t0 => {
  const $ = _c(37);
  const {
    isEditOrder: t1
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const {
    loading: optionsLoading,
    data: t2
  } = usePDPOptions();
  const {
    stock,
    options,
    upholsteryOptionId,
    hasSingleOptionType
  } = t2;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: availabilityLoading,
    data: t3
  } = usePDPStockAvailability();
  const {
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isDiscontinued,
    isOutOfStock,
    isStockLoading
  } = t3;
  const price = basicDetails?.meta?.price;
  const shouldShowReadyToShip = stock?.showReadyToShip && !basicDetails?.bypass_stock;
  let t4;
  if ($[0] !== availabilityLoading || $[1] !== hasSingleOptionType || $[2] !== isDiscontinued || $[3] !== isEFGInternal || $[4] !== isMarkedOOSOrDiscontinued || $[5] !== isOutOfStock || $[6] !== options || $[7] !== optionsLoading) {
    t4 = !availabilityLoading && !optionsLoading && (isEmpty(options) || isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued || isEFGInternal && hasSingleOptionType);
    $[0] = availabilityLoading;
    $[1] = hasSingleOptionType;
    $[2] = isDiscontinued;
    $[3] = isEFGInternal;
    $[4] = isMarkedOOSOrDiscontinued;
    $[5] = isOutOfStock;
    $[6] = options;
    $[7] = optionsLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const hideShopsTabBar = !!t4;
  let t5;
  if ($[9] !== availabilityLoading || $[10] !== isDiscontinued || $[11] !== isEFGInternal || $[12] !== isMarkedOOSOrDiscontinued || $[13] !== isOutOfStock || $[14] !== options || $[15] !== optionsLoading || $[16] !== pdpSelectedCustomizerTab || $[17] !== setPdpSelectedCustomizerTab) {
    t5 = () => {
      if (availabilityLoading || optionsLoading || isEmpty(options)) {
        return;
      }
      if (isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued || isEFGInternal && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID) {
        setPdpSelectedCustomizerTab(PDP_READYTOSHIP_TAB_ID);
      }
    };
    $[9] = availabilityLoading;
    $[10] = isDiscontinued;
    $[11] = isEFGInternal;
    $[12] = isMarkedOOSOrDiscontinued;
    $[13] = isOutOfStock;
    $[14] = options;
    $[15] = optionsLoading;
    $[16] = pdpSelectedCustomizerTab;
    $[17] = setPdpSelectedCustomizerTab;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== availabilityLoading || $[20] !== hasSingleOptionType || $[21] !== isDiscontinued || $[22] !== isEFGInternal || $[23] !== isMarkedOOSOrDiscontinued || $[24] !== isOutOfStock || $[25] !== options || $[26] !== optionsLoading || $[27] !== pdpSelectedCustomizerTab || $[28] !== setPdpSelectedCustomizerTab) {
    t6 = [availabilityLoading, hasSingleOptionType, isDiscontinued, isEFGInternal, isMarkedOOSOrDiscontinued, isOutOfStock, options, optionsLoading, pdpSelectedCustomizerTab, setPdpSelectedCustomizerTab];
    $[19] = availabilityLoading;
    $[20] = hasSingleOptionType;
    $[21] = isDiscontinued;
    $[22] = isEFGInternal;
    $[23] = isMarkedOOSOrDiscontinued;
    $[24] = isOutOfStock;
    $[25] = options;
    $[26] = optionsLoading;
    $[27] = pdpSelectedCustomizerTab;
    $[28] = setPdpSelectedCustomizerTab;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  useEffect(t5, t6);
  const t7 = optionsLoading || isMarkedOOSOrDiscontinued && isStockLoading;
  const t8 = !isEditOrder && !!upholsteryOptionId;
  let t9;
  if ($[30] !== hideShopsTabBar || $[31] !== isEFGInternal || $[32] !== price || $[33] !== shouldShowReadyToShip || $[34] !== t7 || $[35] !== t8) {
    t9 = <PDPShopTabsBarUI hideShopsTabBar={hideShopsTabBar} isEFGInternal={isEFGInternal} loading={t7} price={price} showDecideLater={t8} showReadyToShip={shouldShowReadyToShip} />;
    $[30] = hideShopsTabBar;
    $[31] = isEFGInternal;
    $[32] = price;
    $[33] = shouldShowReadyToShip;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
};
PDPShopTabsBarInner.propTypes = {
  isEditOrder: PropTypes.bool
};
const PDPShopTabsBar = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPShopTabsBarPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <ReRenderOnMount><SuspenseWithLoader fallback={t0}><PDPShopTabsBarInner {...props} /></SuspenseWithLoader></ReRenderOnMount>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPShopTabsBar;